import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', id: '/#hero' },
    { name: 'Services', id: '/#services' },
    { name: 'Products', id: '/#products' },
    { name: 'About', id: '/about-us' },
    { name: 'Contact', id: '/#contact' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-500 font-poppins ${
      scrolled || location.pathname !== '/' ? 'bg-white/90 backdrop-blur-md shadow-lg border-b border-slate-100 py-3' : 'bg-transparent py-5'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" onClick={() => window.scrollTo(0, 0)} className="flex items-center space-x-3 group cursor-pointer">
          <div className="w-10 h-10 bg-gradient-to-tr from-syana-blue-600 to-syana-purple-600 rounded-xl flex items-center justify-center shadow-md transition-transform group-hover:rotate-12">
            <span className="text-xl font-bold text-white">S</span>
          </div>
          <span className={`text-2xl font-bold tracking-tight transition-colors ${scrolled || location.pathname !== '/' ? 'text-slate-900' : 'text-white'}`}>
            Siyane <span className="text-syana-blue-600 font-medium">Optometrists</span>
          </span>
        </Link>

        {/* Desktop Links */}
        <div className={`hidden lg:flex items-center space-x-10 text-[10px] font-black uppercase tracking-[0.3em] transition-colors ${
          scrolled || location.pathname !== '/' ? 'text-slate-600' : 'text-white/70'
        }`}>
          {navLinks.map((link) => (
            link.name === 'About' ? (
              <Link key={link.name} to={link.id} className="hover:text-syana-blue-600 transition-colors relative group">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-syana-blue-600 transition-all group-hover:w-full"></span>
              </Link>
            ) : (
              <a key={link.name} href={link.id} className="hover:text-syana-blue-600 transition-colors relative group">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-syana-blue-600 transition-all group-hover:w-full"></span>
              </a>
            )
          ))}
          <a 
            href="tel:+94117575100"
            className={`px-8 py-3 rounded-xl transition-all shadow-xl font-black uppercase text-[9px] tracking-widest active:scale-95 ${
              scrolled || location.pathname !== '/' ? 'bg-slate-900 text-white hover:bg-syana-blue-600' : 'bg-white text-slate-900 hover:shadow-white/20'
            }`}
          >
            Book Now
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          onClick={() => setIsOpen(!isOpen)}
          className={`lg:hidden w-12 h-12 flex items-center justify-center rounded-2xl transition ${
            scrolled || location.pathname !== '/' ? 'bg-slate-50 text-slate-900 hover:bg-slate-100' : 'bg-white/10 text-white backdrop-blur-md'
          }`}
        >
          <i className={`fa-solid ${isOpen ? 'fa-xmark' : 'fa-bars-staggered'} text-xl`}></i>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="lg:hidden absolute top-full left-0 w-full bg-white border-b border-slate-100 p-10 shadow-2xl animate-fade-in-down overflow-y-auto max-h-[80vh]">
          <div className="flex flex-col space-y-6 text-[11px] font-black text-slate-900 uppercase tracking-[0.3em]">
            {navLinks.map((link) => (
              link.name === 'About' ? (
                <Link key={link.name} to={link.id} onClick={() => setIsOpen(false)} className="hover:text-syana-blue-600 transition-all">
                  {link.name}
                </Link>
              ) : (
                <a key={link.name} href={link.id} onClick={() => setIsOpen(false)} className="hover:text-syana-blue-600 transition-all">
                  {link.name}
                </a>
              )
            ))}
            <a 
              href="tel:+94117575100"
              onClick={() => setIsOpen(false)} 
              className="w-full py-5 bg-slate-900 text-white rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-syana-blue-600 transition-all shadow-2xl shadow-slate-200 text-center active:scale-95"
            >
              Book Appointment
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
